<template>
  <cms-section
    :first-section="firstElement"
    page-context
    :section="{ name: 'filter-by', items }"
  />
</template>

<script setup lang="ts">
import type { FilterByContent } from '#types/components/cms/filter-by'

const { content } = defineProps<{
  content: FilterByContent
  firstElement?: boolean
}>()

const route = useRoute()

const items = computed(() => filterContentBy(content, route))
</script>
